<form [formGroup]="step4Form">
    <div class="flex flex-col gap-4 md:flex-row md:gap-0 flex-wrap justify-around my-6">
        <!-- Logotipo -->
        <div class="flex flex-col justify-center items-center content-center gap-2">
            <div class="font-bold">Agrega un logotipo</div>
            <div class="upload-photo logo" [class.upload-photo--vacia]="!temporaryImageLogo && !tenant.logoExists"
                appFileDrop fileDropAccept="image/png, image/jpeg, image/jpg" [fileDropDisabled]="resizing$ | async"
                (fileDropped)="addNewPhoto($event, 'logo')" (fileRejected)="onPhotoRejected()">
                <label for="photoURL" title="Haz clic para subir una imagen">
                    <img *ngIf="temporaryImageLogo || tenant.logoExists" class="tenant-img-logo" width="360" height="64"
                        [src]="temporaryImageLogo || tenant.logoPath" alt="Logotipo" />
                    <span *ngIf="!temporaryImageLogo && !tenant.logoExists" class="upload-photo__vacio">
                        <img src="assets/images/upload-image.svg" class="upload-photo__icono" alt="">
                        <span class="upload-photo__texto">Haz clic o arrastra para subir el logotipo</span>
                    </span>
                </label>
                <input #photoURL id="photoURL" type="file" accept="image/png, image/jpeg, image/jpg"
                    (change)="addNewPhoto(photoURL.files, 'logo')" />
            </div>
            <div>Tamaño recomendado: 360px x 64px</div>
        </div>

        <!--Escudo -->
        <div class="flex flex-col justify-center items-center content-center gap-2">
            <div class="font-bold">Agrega un escudo</div>
            <div class="upload-photo escudo" [class.upload-photo--vacia]="!temporaryImageShield && !tenant.logoEscudoExists"
                appFileDrop fileDropAccept="image/png, image/jpeg, image/jpg" [fileDropDisabled]="resizing$ | async"
                (fileDropped)="addNewPhoto($event, 'shield')" (fileRejected)="onPhotoRejected()">
                <label for="shieldURL" title="Haz clic para subir una imagen">
                    <img *ngIf="temporaryImageShield || tenant.logoEscudoExists" class="tenant-img-badge" width="64" height="64"
                        [src]="temporaryImageShield || tenant.logoEscudoPath" alt="Escudo" />
                    <span *ngIf="!temporaryImageShield && !tenant.logoEscudoExists" class="upload-photo__vacio">
                        <img src="assets/images/upload-image.svg" class="upload-photo__icono" alt="">
                        <span class="upload-photo__texto">Haz clic o arrastra para subir el escudo</span>
                    </span>
                </label>
                <input #shieldURL id="shieldURL" type="file" accept="image/png, image/jpeg, image/jpg"
                    (change)="addNewPhoto(shieldURL.files, 'shield')" />
            </div>
            <div>Tamaño recomendado: 64px x 64px</div>
        </div>
    </div>

    <span class="text-[20px] font-bold">Datos generales</span>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <mat-form-field class="w-full">
            <mat-label>País de origen</mat-label>
            <mat-select formControlName="country">
                <mat-option>
                    <ngx-mat-select-search formControlName="filterCountry" placeholderLabel="Buscar..."
                        noEntriesFoundLabel="'Sin Resultados'">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="
                        let p of countries
                            | search
                                : step4Form.get('filterCountry').value
                                : ['name_es']
                    " [value]="p.id">{{ p.name_es }}</mat-option>
            </mat-select>
            <mat-error *ngIf="step4Form.get('country')?.hasError('required')">El país es requerido</mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Región de origen</mat-label>
            <mat-select formControlName="region">
                <mat-option>
                    <ngx-mat-select-search formControlName="filterRegion" placeholderLabel="Buscar..."
                        noEntriesFoundLabel="'Sin Resultados'">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="
                        let r of regiones
                            | search
                                : step4Form.get('filterRegion').value
                                : ['name']
                    " [value]="r.id">{{ r.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="step4Form.get('region')?.hasError('required')">La región es requerida</mat-error>
        </mat-form-field>
        <div class="relative">
            <mat-form-field class="w-full">
                <mat-label>Alias</mat-label>
                <input matInput formControlName="alias" placeholder="Ingresa un alias para la empresa"
                    [readonly]="isReadOnly"  (input)="toLowercaseAlias()" />
                <mat-error *ngIf="step4Form.get('alias')?.hasError('required')">El alias es requerido</mat-error>
                <mat-error *ngIf="step4Form.get('alias')?.hasError('maxlength')">
                    Máximo 16 caracteres permitidos
                </mat-error>
            </mat-form-field>
            <mat-icon class="text-[22px] absolute -top-[22px] right-0 cursor-pointer"
                matTooltip="Ingresa una abreviación única para identificar tu cuenta. Ejemplos: abc, xyz. Máximo 16 caracteres."
                matTooltipPosition="above" *ngIf="mode === 'step'">help</mat-icon>
        </div>
    </div>

    <span class="text-[20px] font-bold">Datos de facturación</span>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <mat-form-field class="w-full">
            <mat-label>Tipo de documento</mat-label>
            <mat-select formControlName="documentType">
                <mat-option *ngFor="let doc of documentTypes" [value]="doc.id">{{ doc.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="step4Form.get('documentType')?.hasError('required')">El tipo de documento es
                requerido</mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Nro de documento</mat-label>
            <input matInput formControlName="documentNumber" placeholder="Ingresa el número de documento" />
            <mat-error *ngIf="step4Form.get('documentNumber')?.hasError('required')">El número de documento es
                requerido</mat-error>
            <mat-error *ngIf="step4Form.get('documentNumber')?.hasError('minlength')">
                Debe tener 3 dígitos como mínimo
            </mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Sector industrial</mat-label>
            <mat-select formControlName="industrialSector">
                <mat-option>
                    <ngx-mat-select-search formControlName="filterIdustrialSector" placeholderLabel="Buscar..."
                        noEntriesFoundLabel="'Sin Resultados'">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="
                        let p of industrial
                            | search
                                : step4Form.get('filterIdustrialSector').value
                                : ['descripcion']
                    " [value]="p.id">{{ p.descripcion }}</mat-option>
            </mat-select>

            <mat-error *ngIf="step4Form.get('industrialSector')?.hasError('required')">La razón social es
                requerida</mat-error>
        </mat-form-field>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <mat-form-field class="w-full">
            <mat-label>Razón social</mat-label>
            <input matInput formControlName="companyName" placeholder="Razón social de la empresa" />
            <mat-error *ngIf="step4Form.get('companyName')?.hasError('required')">La razón social es
                requerida</mat-error>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Dirección</mat-label>
            <input matInput formControlName="address" placeholder="Dirección completa de la empresa" />
            <mat-error *ngIf="step4Form.get('address')?.hasError('required')">La dirección es requerida</mat-error>
        </mat-form-field>
    </div>

    <div class="flex flex-col">
        <span class="text-[20px] font-bold" *ngIf="mode === 'step'">Información adicional</span>
        <span class="text-[20px] font-bold" *ngIf="mode === 'configuration'">Configuración Adicional</span>

        <span *ngIf="mode === 'step'">
            Al finalizar con el registro, se realizará a través de la plataforma
            <a href="https://www.openpay.pe/" target="_blank" class="text-blue-600 underline">Openpay</a>, el registro
            de la información de pago. Si el plan que usted ha
            escogido tiene un periodo de prueba, el cobro se realizará al día
            siguiente de finalizado dicho periodo.
        </span>

        <mat-checkbox formControlName="additionalConfig" class="mt-2">
            <div *ngIf="mode === 'step'">
                Acepto los
                <a href="/terminos-y-condiciones" target="_blank" class="text-blue-600 underline">términos y
                    condiciones</a>
                y la
                <a href="/politica-de-privacidad" target="_blank" class="text-blue-600 underline">política de
                    privacidad</a>
                de Agente de Prensa.
            </div>
            <div *ngIf="mode === 'configuration'">
                Hacer obligatorio la valorización y alcance de impacto.
            </div>
        </mat-checkbox>
        <mat-error *ngIf="step4Form.get('additionalConfig')?.hasError('requiredTrue')">
            Debe aceptar los términos y condiciones.
        </mat-error>
    </div>

    <div class="flex justify-center gap-4 mt-6" *ngIf="mode === 'step'">
        <button mat-raised-button color="secondary" (click)="onVolver.emit()">
            Volver
        </button>

        <button type="submit" mat-raised-button color="primary" (click)="finalizar()" class="button-submit"
            [disabled]="!step4Form.valid || registerLoading">
            <mat-icon [class.animate-spin]="registerLoading">{{
                serverLoading ? "autorenew" : "save"
                }}</mat-icon>
            Finalizar
        </button>
    </div>

    <div class="flex justify-end mt-6" *ngIf="mode === 'configuration'">
        <!-- <button mat-raised-button color="primary" (click)="onSaveForm()">Guardar</button> -->
        <button type="submit" mat-raised-button color="primary" (click)="onSaveForm()" class="button-submit"
            [disabled]="!step4Form.dirty || step4Form.invalid || serverLoading">
            <mat-icon [class.animate-spin]="serverLoading">{{
                serverLoading ? "autorenew" : "save"
                }}</mat-icon>
            Guardar
        </button>
    </div>
</form>
